import React from 'react';

interface LabourCostChartModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSelectRate: (payload: { aedKg: number; costPerSqm: number; labourRateHr: number }) => void;
}

export const LabourCostChartModal: React.FC<LabourCostChartModalProps> = ({ isOpen, onClose, onSelectRate }) => {
    if (!isOpen) return null;

    // Data from Screenshot
    const chartData = [
        { capacity: 150, sqmPerDay: 10, manHrs: 66, costPerSqm: 91, inefficiency: 25, kgHr: 1.81, labourRate: 10, aedKg: 5.5 },
        { capacity: 450, sqmPerDay: 15, manHrs: 66, costPerSqm: 61, inefficiency: 25, kgHr: 5.45, labourRate: 10, aedKg: 1.83 },
        { capacity: 600, sqmPerDay: 20, manHrs: 66, costPerSqm: 46, inefficiency: 25, kgHr: 7.27, labourRate: 10, aedKg: 1.375 },
        { capacity: 750, sqmPerDay: 25, manHrs: 66, costPerSqm: 36, inefficiency: 25, kgHr: 9.09, labourRate: 10, aedKg: 1.1 },
        { capacity: 900, sqmPerDay: 30, manHrs: 66, costPerSqm: 30, inefficiency: 25, kgHr: 10.9, labourRate: 10, aedKg: 0.916 },
        { capacity: 1050, sqmPerDay: 35, manHrs: 66, costPerSqm: 26, inefficiency: 25, kgHr: 12.72, labourRate: 10, aedKg: 0.785 },
        { capacity: 1200, sqmPerDay: 40, manHrs: 66, costPerSqm: 23, inefficiency: 25, kgHr: 14.54, labourRate: 10, aedKg: 0.6875 },
        { capacity: 1350, sqmPerDay: 45, manHrs: 66, costPerSqm: 20, inefficiency: 25, kgHr: 16.36, labourRate: 10, aedKg: 0.611 },
        { capacity: 1500, sqmPerDay: 50, manHrs: 72, costPerSqm: 19, inefficiency: 25, kgHr: 16.66, labourRate: 10, aedKg: 0.6 },
        { capacity: 1650, sqmPerDay: 55, manHrs: 79.2, costPerSqm: 19, inefficiency: 25, kgHr: 16.66, labourRate: 10, aedKg: 0.6 },
        { capacity: 1800, sqmPerDay: 60, manHrs: 86.4, costPerSqm: 19, inefficiency: 25, kgHr: 16.66, labourRate: 10, aedKg: 0.6 },
        { capacity: 1950, sqmPerDay: 65, manHrs: 93.6, costPerSqm: 18, inefficiency: 25, kgHr: 16.66, labourRate: 10, aedKg: 0.6 },
        { capacity: 2100, sqmPerDay: 70, manHrs: 100.8, costPerSqm: 18, inefficiency: 25, kgHr: 16.66, labourRate: 10, aedKg: 0.6 },
        { capacity: 2250, sqmPerDay: 75, manHrs: 108, costPerSqm: 18, inefficiency: 25, kgHr: 16.66, labourRate: 10, aedKg: 0.6 },
        { capacity: 2400, sqmPerDay: 80, manHrs: 115.2, costPerSqm: 18, inefficiency: 25, kgHr: 16.66, labourRate: 10, aedKg: 0.6 },
        { capacity: 2550, sqmPerDay: 85, manHrs: 122.4, costPerSqm: 17, inefficiency: 25, kgHr: 16.66, labourRate: 10, aedKg: 0.6 },
        { capacity: 2700, sqmPerDay: 90, manHrs: 130, costPerSqm: 17, inefficiency: 25, kgHr: 16.61, labourRate: 10, aedKg: 0.601 },
        { capacity: 2850, sqmPerDay: 95, manHrs: 137, costPerSqm: 17, inefficiency: 25, kgHr: 16.64, labourRate: 10, aedKg: 0.6 },
        { capacity: 3000, sqmPerDay: 100, manHrs: 144, costPerSqm: 17, inefficiency: 25, kgHr: 16.66, labourRate: 10, aedKg: 0.6 }
    ];

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center -z-50" style={{ zIndex: 9999 }}>
            <div className="bg-white rounded-lg shadow-lg w-full max-w-5xl overflow-hidden font-sans text-xs">
                {/* Header */}
                <div className="bg-gray-800 text-white px-4 py-2 flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <span className="text-xl font-bold">Labour Cost Chart</span>
                    </div>
                    <button onClick={onClose} className="text-white hover:text-gray-300">Close</button>
                </div>

                {/* Table */}
                <div className="p-4 max-h-[80vh] overflow-y-auto">
                    <table className="w-full border-collapse border text-center">
                        <thead className="bg-blue-200">
                            <tr>
                                <th className="border p-1"></th>
                                <th className="border p-1">Spray Machine capacity Kg / day</th>
                                <th className="border p-1">SQM per day</th>
                                <th className="border p-1">Labours ManHrs</th>
                                <th className="border p-1">Cost per SQM</th>
                                <th className="border p-1">Labour Inefficiency Factor</th>
                                <th className="border p-1">Kg/Hr</th>
                                <th className="border p-1">Labour Rate/Hr</th>
                                <th className="border p-1 bg-green-100">AED/Kg</th>
                            </tr>
                        </thead>
                        <tbody>
                            {chartData.map((row, idx) => (
                                <tr key={idx} className="hover:bg-blue-50 border-b">
                                    <td className="border p-1">
                                        <button
                                            onClick={() => onSelectRate({ aedKg: row.aedKg, costPerSqm: row.costPerSqm, labourRateHr: row.labourRate })}
                                            className="bg-gray-800 text-white px-3 py-1 rounded text-xs hover:bg-gray-700"
                                        >
                                            Select
                                        </button>
                                    </td>
                                    <td className="border p-1">{row.capacity}</td>
                                    <td className="border p-1">{row.sqmPerDay}</td>
                                    <td className="border p-1">{row.manHrs}</td>
                                    <td className="border p-1">{row.costPerSqm}</td>
                                    <td className="border p-1">{row.inefficiency}</td>
                                    <td className="border p-1">{row.kgHr}</td>
                                    <td className="border p-1">{row.labourRate}</td>
                                    <td className="border p-1 bg-green-50 font-bold">{row.aedKg}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
